import MessagesTypes from "./messages.types";
import { ChatMessageSendStatus, IChatMessage } from "./messages.state";
import { FileMessageStatus } from "@missionlabs/smartagent-chat-components-lib/dist/ChatMessage/chat-message.types";

interface ISendMessageAction {
    type: MessagesTypes.SEND_MESSAGE;
    payload: {
        message: string | IChatMessage,
        displayAs?: string,
        contentType?: connect.ChatMessageContentType,
    }
}

export type MessagesAction =
    | ISendMessageAction
    | { type: MessagesTypes.NEW_MESSAGE, payload: IChatMessage }
    | { type: MessagesTypes.SET_MESSAGE_STATUS, payload: { id: string, status: ChatMessageSendStatus }}
    | { type: MessagesTypes.CLEAR_MESSAGES }
    | { type: MessagesTypes.SEND_FILE, payload: any }
    | { type: MessagesTypes.GET_TRANSCRIPT }
    | { type: MessagesTypes.SET_DELIVERED_TIMESTAMP, payload: { id: string, deliveredTimestamp: string } }
    | { type: MessagesTypes.SET_READ_TIMESTAMP, payload: { id: string, readTimestamp: string } }
    | { type: MessagesTypes.MARK_CHAT_MESSAGE_RECEIPTS_AS_READ }
    | { type: MessagesTypes.SET_ATTACHMENT_STATUS, payload: { status: FileMessageStatus, id: string } }


export const newMessageAction = (payload: IChatMessage) : MessagesAction => ({
    type: MessagesTypes.NEW_MESSAGE,
    payload
})

export const clearMessages = () : MessagesAction => ({
    type: MessagesTypes.CLEAR_MESSAGES
})
export const setMessageStatus = (id: string, status: ChatMessageSendStatus) : MessagesAction => ({
    type: MessagesTypes.SET_MESSAGE_STATUS,
    payload: {
        id,
        status
    }
})

export const sendMessage = (
    message: string,
    displayAs?: string,
    contentType?: connect.ChatMessageContentType,
): MessagesAction => {
    return {
        type: MessagesTypes.SEND_MESSAGE,
        payload: {
            message,
            displayAs,
            contentType,
        },
    }
}

export const sendFile = (payload: {file: File, fileName: string}) : MessagesAction => {
    return {
        type: MessagesTypes.SEND_FILE,
        payload,
    } 
}

export const setDeliveredTimestamp = (id: string, deliveredTimestamp: string): MessagesAction => {
    return {
        type: MessagesTypes.SET_DELIVERED_TIMESTAMP,
        payload: {
            id,
            deliveredTimestamp,
        },
    }
}

export const setReadTimestamp = (id: string, readTimestamp: string): MessagesAction => {
    return {
        type: MessagesTypes.SET_READ_TIMESTAMP,
        payload: {
            id,
            readTimestamp
        },
    }
}

export const markChatMessageReceiptsAsRead = () : MessagesAction => {    
    return {
        type: MessagesTypes.MARK_CHAT_MESSAGE_RECEIPTS_AS_READ
    }
}

export const setAttachmentStatus = (status: FileMessageStatus, id: string): MessagesAction => {
    return {
        type: MessagesTypes.SET_ATTACHMENT_STATUS,
        payload: {
            status,
            id
        }
    }
}
